import { MemberSeatResponse } from "../contracts/MemberSeatResponse";
import { OccurrenceOccupancyResponse } from "../contracts/OccurrenceOccupancyResponse";
import { SeatStatus } from "../enums/SeatStatus";
import { MemberSeat } from "../models/MemberSeat";
import { OccurrenceOccupancy } from "../models/OccurrenceOccupancy";

/** Wire → model for a Session's per-date occupancy and a member's booked dates. */
export class OccupancyResponseMapper {
  toOccupancy(response: OccurrenceOccupancyResponse): OccurrenceOccupancy {
    return {
      date: response.date,
      rosterCount: response.rosterCount,
      confirmedSeats: response.confirmedSeats,
      requestedSeats: response.requestedSeats,
      capacity: response.capacity ?? null,
      isFull: response.isFull,
      occupied: response.rosterCount + response.confirmedSeats + response.requestedSeats,
    };
  }

  /** A missing list (null / undefined) maps to no dates. */
  toOccupancies(responses: OccurrenceOccupancyResponse[] | null | undefined): OccurrenceOccupancy[] {
    return (responses ?? []).map((r) => this.toOccupancy(r));
  }

  toMemberSeat(response: MemberSeatResponse): MemberSeat {
    return {
      bookingId: response.bookingId,
      sessionName: response.sessionName,
      date: response.date,
      start: response.start.slice(0, 5),
      timeZone: response.timeZone,
      status: response.status,
      source: response.source,
      isPending: response.status === SeatStatus.Requested,
    };
  }

  /** A missing list (null / undefined) maps to no seats. */
  toMemberSeats(responses: MemberSeatResponse[] | null | undefined): MemberSeat[] {
    return (responses ?? []).map((r) => this.toMemberSeat(r));
  }
}
